<!-- 采购订单 -->
<template>
  <div class="my-mad-department p5 m5 bw br5">
    <div class="header-style mb5">
      采购订单
    </div>
    <!--    <search-vue ref="searchVue" :columns="tableSet.columns" :valueSet="valueSet" :onlyKey="'purchaseOrder'"></search-vue>-->
    <div class="fix">
      <q-input class="w180 l mr10" outlined placeholder="输入采购订单号查询" v-model="query.FBillNo" dense square clearable>
        <q-tooltip>采购订单号</q-tooltip>
      </q-input>
      <q-input class="w180 l mr10" outlined placeholder="输入采购申请单单号查询" v-model="query.FPRBILLNO" dense square clearable>
        <q-tooltip>采购申请单单号</q-tooltip>
      </q-input>
      <q-input class="w180 l mr10" outlined placeholder="输入销售订单编号查询" v-model="query.FBillNoXS" dense square clearable>
        <q-tooltip>销售订单编号</q-tooltip>
      </q-input>
      <q-btn size='9px' class="l mr10" @click="popupProxy = !popupProxy" :icon="popupProxy ? 'fas fa-angle-double-up' : 'fas fa-angle-double-down'">
      </q-btn>

      <q-btn size='9px' class="l mr10" color="primary" icon="fas fa-search" @click="search"></q-btn>
      <q-btn size='9px' class="l mr10" icon="fas fa-redo" @click="resetSearch"></q-btn>
    </div>
    <div class="fix mt5" v-if="popupProxy">
      <q-input class="w180 l mr10" outlined placeholder="输入施耐德发货单号（80号）查询" v-model="query.VBELN" dense square
                clearable>
                <q-tooltip>施耐德发货单号（80号）</q-tooltip>
              </q-input>
              <q-input class="w180 l mr10" outlined placeholder="输入订货号查询" v-model="query.MATNR" dense square
                clearable>
                <q-tooltip>订货号</q-tooltip>
              </q-input>
              <q-input class="w180 l mr10" outlined placeholder="输入规格型号查询" v-model="query.FModel" dense square
                clearable>
                <q-tooltip>规格型号</q-tooltip>
              </q-input>
              <q-input class="w180 l mr10" outlined placeholder="输入销售订单备注查询" v-model="query.FNote" dense square
                clearable>
              </q-input>
    </div>
    <div>
      <base-table v-if="!tableSet.loading" @tool_click="tool_click" :tableSet="tableSet"
        @changeRowsPage="changeRowsPage" @changePage="changePage" @updateSelected="updateSelected"></base-table>
      <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import API from '@/apis/index';
import BaseTable from '@/components/pieces/tables/default-table.vue';
import { useStore } from "vuex";
import { tableHeight } from "@/tools/lines.js";
import { getRandomString } from '@/tools/utils.js'
import { useRouter } from "vue-router";
import searchVue from '@/components/pieces/search/search.vue';
import { isNotEmpty } from "@/tools/utils";
export default {
  name: "purchaseOrder",
  components: {
    BaseTable
  },
  setup() {
    let store = useStore();
    let tab = ref('tjdzt');
    const router = useRouter();
    let valueSet = ref({});
    let popupProxy = ref(false);
    let formData = ref({
      keys: '',
      Fpp: '',
      Fdhh: '',
      Fxj: '',
      Fmx: '',
    });
    let tableSet = store.getters["purchaseOrder/getTable"];
    let query = ref({
      FBillNo: '',
      FModel: '',
      FNote: '',
      FBillNoXS: '',
      VBELN: '',
      MATNR: '',
      FPRBILLNO: '',
    })
    let changeRowsPage = (value) => {
      localStorage.setItem("pageSize", value);
      tableSet.pagination.rowsPerPage = value;
      getTableData();
    }
    let changePage = (value) => {
      tableSet.pagination.page = value;
      getTableData();
    }
    let updateSelected = (data) => {
      store.dispatch('purchaseOrder/getSoEntryList')
    }
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("purchaseOrder/setTableHeight", tableHeight());
    }
    function getParams() {
      let params = {
        pagination: {
          rowsPerPage: tableSet.pagination.rowsPerPage,
          page: tableSet.pagination.page
        },
        query: {}
      };
      if (isNotEmpty(query.value.FBillNo)) {
        params.query.FBillNo = query.value.FBillNo.trim();
      }
      if (isNotEmpty(query.value.FModel)) {
        params.query.FModel = query.value.FModel.trim();
      }
      if (isNotEmpty(query.value.FNote)) {
        params.query.FNote = query.value.FNote.trim();
      }
      if (isNotEmpty(query.value.FBillNoXS)) {
        params.query.FBillNoXS = query.value.FBillNoXS.trim();
      }
      if (isNotEmpty(query.value.VBELN)) {
        params.query.VBELN = query.value.VBELN.trim();
      }
      if (isNotEmpty(query.value.MATNR)) {
        params.query.MATNR = query.value.MATNR.trim();
      }
      if (isNotEmpty(query.value.FPRBILLNO)) {
        params.query.FPRBILLNO = query.value.FPRBILLNO.trim();
      }
      return params
    }
    function search() {
      tableSet.pagination.page = 1;
      getTableData();
    }
    function resetSearch() {
      query.value = {
        FBillNo: '',
        FModel: '',
        FNote: '',
        FBillNoXS: '',
        VBELN: '',
        MATNR: '',
        FPRBILLNO: '',
      };
      tableSet.pagination.page = 1;
      getTableData();
    }
    function getTableData() {
      let params = getParams();
      store.dispatch("purchaseOrder/getList", params)
    }
    function init() {
      store.commit("purchaseOrder/setResetFun", getTableData);
      getTableData();
    }
    onMounted(() => {
      init();
      refreshTableHeight();
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    });
    function tool_click(type) {
    }
    return {
      formData,
      search,
      tableSet,
      tool_click,
      tab,
      valueSet,
      changeRowsPage,
      changePage,
      updateSelected,
      query,
      resetSearch,
      popupProxy
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep .q-field--dense .q-field__control {
  min-height: 24px;
  height: 24px;
  font-size: 12px;
}
</style>